export const modals = {
  users: {
    fields: {
      name: 'Имя',
      surname: 'Фамилия',
      login: 'Логин',
    },
    filters: {
      shiftsCalendarPage: [
        {
          field: 'calendar_id',
          predicate: 'is',
          value: null,
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/constants/modals.js